import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as common from '../../../../../common'
import * as models from '../../models'

import * as gql from './gql'

@ngCore.Injectable()
export class ApiService {
  /** TODO:  */
  public render(
    request: models.widget.Request,
  ): rxjs.Observable<ents.core.mosaic.Widget.Rendering | undefined> {
    const {
      pageContext: { appId, appPageId, tenantId, zoneId },
      ref: { widget },
      variables,
    } = request
    return gql.queries.mosaicPageRenderingWidget.executor({
      appId,
      appPageId,
      // FIXME: ScenarioId is required by GraphQL for widget rendering, but not
      // all applications support scenarios.
      // Consider refactoring mosaicPageRenderingWidget to remove it from scenario query
      scenarioId: 'TODO',
      tenantId,
      variableOverrides:
        common.gql.dms.data.inputs.variableValue.TRANSFORMER.getGqlFrom(
          variables,
        ),
      widgetIdentifier: widget,
      zoneId,
    })
  }
}
